import { createReducer, on } from '@ngrx/store';
import { SidecarEfffectActions } from '@src/suite/common/store/fullscreen';
import { MosState } from '@src/suite/common/store/mos/models/mos.models';

import { StoryMosActions } from '../../story/actions/story.actions';

const initialState: MosState = {
    currentStoryMos: null,
};
export const mosReducer = createReducer(
    initialState,
    on(
        SidecarEfffectActions.openMosItem,
        (state, action): MosState => ({
            ...state,
            currentStoryMos: {
                mosElementId: action.mosItemId,
                storyId: action.storyId,
            },
        })
    ),
    on(
        StoryMosActions.requestMOSStoryRecord,
        (state, action): MosState => ({
            ...state,
            currentStoryMos: {
                ...(state.currentStoryMos ?? {
                    mosElementId: null,
                    storyId: null,
                }),
                storyId: action.story?.Guid,
            },
        })
    ),
    on(
        StoryMosActions.setCurrentMosItem,
        (state, action): MosState => ({
            ...state,
            currentStoryMos: {
                storyId: action.storyId,
                mosElementId: action.mosElementId,
            },
        })
    )
);
